import { Box, Typography } from "@mui/material";
import React from "react";
import type { RoleFaqsOutcomes } from "../../content/roleFaqsContent";

interface OutcomesSectionProps {
  outcomes: RoleFaqsOutcomes;
  id?: string;
}

const OutcomesSection: React.FC<OutcomesSectionProps> = ({
  outcomes,
  id = "outcomes",
}) => {
  return (
    <Box id={id} component="section" sx={{ mb: 6 }}>
      <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: "bold" }}>
        Expected Outcomes
      </Typography>
      <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
        {outcomes.description}
      </Typography>
      {outcomes.problemSolved && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
            Problem Solved:
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
            {outcomes.problemSolved}
          </Typography>
        </Box>
      )}
      {outcomes.outcomeMetrics && outcomes.outcomeMetrics.length > 0 && (
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
            Outcome Metrics:
          </Typography>
          <Box component="ul" sx={{ pl: 3, m: 0 }}>
            {outcomes.outcomeMetrics.map((m, i) => (
              <li key={i}>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  {m}
                </Typography>
              </li>
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default OutcomesSection;
